import { LucideIcon, Sparkles } from "lucide-react";

type Tone = "primary" | "destructive" | "muted";

interface AuthHeroIconProps {
  icon: LucideIcon;
  tone?: Tone;
  sparkle?: boolean;
}

/**
 * Spójna ikona-bohater do widoków auth/onboarding:
 * - duże, gradientowe kółko z ikoną
 * - opcjonalna iskierka w rogu (sukces)
 * - delikatna poświata w tle
 */
export const AuthHeroIcon = ({ icon: Icon, tone = "primary", sparkle = false }: AuthHeroIconProps) => {
  const toneMap: Record<Tone, { bg: string; glow: string; icon: string; shadow: string }> = {
    primary: {
      bg: "bg-gradient-to-br from-primary to-primary/80",
      glow: "from-primary/20 to-primary/5",
      icon: "text-primary-foreground",
      shadow: "shadow-primary/30",
    },
    destructive: {
      bg: "bg-gradient-to-br from-destructive to-destructive/80",
      glow: "from-destructive/20 to-destructive/5",
      icon: "text-destructive-foreground",
      shadow: "shadow-destructive/20",
    },
    muted: {
      bg: "bg-gradient-to-br from-muted-foreground/80 to-muted-foreground/60",
      glow: "from-muted-foreground/20 to-muted-foreground/5",
      icon: "text-background",
      shadow: "shadow-muted-foreground/20",
    },
  };
  const t = toneMap[tone];

  return (
    <div className="relative">
      <div className={`absolute -inset-3 rounded-full bg-gradient-to-br ${t.glow} blur-xl`} />
      <div className={`relative h-20 w-20 rounded-full ${t.bg} flex items-center justify-center shadow-lg ${t.shadow}`}>
        <Icon className={`h-10 w-10 ${t.icon}`} strokeWidth={2.5} />
      </div>
      {sparkle && (
        <Sparkles className="absolute -top-1 -right-1 h-5 w-5 text-primary animate-pulse" />
      )}
    </div>
  );
};
